import { type AppDispatch } from '../../../store'
import * as OperationPermissionService from '../services/operationPermissionService'
import * as KeyVaultService from '../services/fetchFromKeyVaultService'
import { operationPermissionErrorAction, operationPermissionLoadingAction, operationPermissionUpdateAction } from '../redux/operationPermissionSlice'
import { fetchKeysErrorAction, fetchKeysLoadingAction, fetchKeysUpdateAction } from './keysFromKeyVaultSlice'

export const getOperationPermissions = (subId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(operationPermissionLoadingAction())

  void OperationPermissionService.getPermissions(
    subId,
    (associateAssetsResponse) => {
      dispatch(operationPermissionUpdateAction({ data: associateAssetsResponse }))
    },
    (error, httpStatus) => {
      dispatch(operationPermissionErrorAction({ error, httpStatus }))
    }
  )
}

export const fetchKeyFromKeyVault = (keyVaultKey: string, keyName: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(fetchKeysLoadingAction())

  void KeyVaultService.fetchFromKeyVault(
    keyVaultKey,
    (keyVaultResponse) => {
      const keyValue = keyVaultResponse.data[keyName] ?? ''
      dispatch(fetchKeysUpdateAction({ KEY: keyName, VALUE: keyValue }))
    },
    (error: string) => {
      dispatch(fetchKeysErrorAction(error))
    }
  )
}
